import * as React from 'react';
import * as firebase from 'firebase/app';
import { Dispatch } from 'react-redux';
import { Table, Card, Button, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AppState, Merchant, Category } from 'src/store';
import { actions as toast } from 'src/toast';
import ButtonGroup from 'antd/lib/button/button-group';
import { Subscription } from 'rxjs';
import { querySnapShot$ } from 'src/util';

const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    navigate: (route: string) => {
      dispatch(push(route));
    },
    onEdit: (id: string) => { dispatch(push(`/merchants/edit/${id}`)); },
    onView: (id: string) => { dispatch(push(`/merchants/view/${id}`)); },
    onDelete: async (id: string) => {
      const ref = firebase.firestore().collection('merchants');
      if (id) {
        const doc = ref.doc(id)
        await doc.delete()
        dispatch(toast.success('Merchant is deleted successfully.'));
        // dispatch(push('/merchants'));
      }
    },
  };
};

interface P {
  navigate: (route: string) => void;
  onEdit: (id: string) => void;
  onView: (id: string) => void;
  onDelete: (id: string) => Promise<void>;
}
type S = {
  status: 'none' | 'loading';
} | {
  status: 'loaded';
  data: Merchant[];
  showModal: boolean;
}
class MerchantList extends React.Component<P, S> {
  columns: ColumnProps<Merchant>[];
  subscription: Subscription;

  constructor(props: P) {
    super(props);
    this.state = { status: 'none' };
    this.subscription = new Subscription();
  }

  componentDidMount() {
    this.setState({ status: 'loading' });
    const query = firebase.firestore()
      .collection('merchants')
      .orderBy('legacy', 'asc')
      .orderBy('memberCount', 'desc');

    this.subscription = querySnapShot$(query)
      .subscribe(qsn => {
        const data = qsn.docs.map(d => ({ id: d.id, ...d.data() } as Merchant));
        this.setState({ status: 'loaded', data, showModal: false });
      });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleOnAdd = () => {
    const { navigate } = this.props;
    navigate(`/merchants/create`);
  }

  getCategoryNames = (categories?: Category[]) => {
    let resultString = "";
    if (categories && categories.length > 0) {
      categories.forEach(category => {
        resultString += category.name + ", ";
      })
      // remove the extra comma at the end, using a regex
      resultString = resultString.replace(/,(?=[^,]*$)/, '')
    }
    return resultString
  }

  render() {
    const { onEdit, onView } = this.props;

    this.columns = [{
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      width: '5%',
      render: (text: string, record: Merchant) => {
        return <span>{record.no}</span>;
      }
    },
    {
      title: 'Business Name',
      dataIndex: 'businessName',
      key: 'businessName',
      width: '18%',
      render: (text: string, record: Merchant) => {
        return <span style={{ wordBreak:'break-all'}}>{record.businessName}</span>;
      }
    },
    {
      title: 'Contact Name',
      dataIndex: 'contactName',
      key: 'contactName',
      width: '10%',
      render: (text: string, record: Merchant) => {
        return <span style={{ wordBreak:'break-all'}}>{record.contactName}</span>;
      }
    },
    {
      title: 'Login Name',
      dataIndex: 'loginUserName',
      key: 'loginUserName',
      width: '12%',
      render: (text: string, record: Merchant) => {
        return <span style={{ wordBreak:'break-all'}}>{record.loginUserName}</span>;
      }
    },
    // {
    //   title: 'Email',
    //   dataIndex: 'email',
    //   key: 'email',
    //   width: '10%',
    // },
    {
      title: 'Category',
      // dataIndex: 'creat',
      width: '20%',
      // tslint:disable-next-line:no-any
      render: (text: string, record: Merchant) => {
        return <span style={{ wordBreak:'break-all'}}>{this.getCategoryNames(record.categories)}</span>;
      }
    },
    {
      title: 'Member Count',
      dataIndex: 'memberCount',
      key: 'memberCount',
      width: '5%',
    }, {
      title: 'Legacy',
      // dataIndex: 'creat',
      width: '5%',
      sorter: (a: Merchant, b: Merchant) => (a.legacy ? 'Unpaid' : 'Paid').localeCompare(b.legacy ? 'Unpaid' : 'Paid'),
      // tslint:disable-next-line:no-any
      render: (text: string, record: Merchant) => {
        return <span>{record.legacy ? 'Unpaid' : 'Paid'}</span>;
      }
    }, {
      title: 'Disabled',
      // dataIndex: 'creat',
      width: '5%',
      sorter: (a: Merchant, b: Merchant) => (a.disabled ? 'Yes' : 'No').localeCompare(b.disabled ? 'Yes' : 'No'),
      // tslint:disable-next-line:no-any
      render: (text: string, record: Merchant) => {
        return <span>{record.disabled ? 'Yes' : 'No'}</span>;
      }
    }
    // ,{
    //   title: 'Facebook',
    //   dataIndex: 'fbId',
    //   key: 'fbId',
    //   width: '13%',
    //   render: (text: string, record: Merchant) => {
    //     return <span style={{ wordBreak:'break-all'}}>{record.fbId}</span>;
    //   }
    // }, 
    ,{
      title: 'Action',
      key: 'action',
      align: 'center',
      width: '12%',
      render: (text: string, record: Merchant) => {

        return (
          <ButtonGroup>
            <Tooltip placement="top" title="Click to edit merchant">
              <Button
                icon="edit"
                // tslint:disable-next-line:jsx-no-lambda
                onClick={() => { onEdit(record.id); }}
              />
            </Tooltip>
            <Button
              icon="eye"
              // tslint:disable-next-line:jsx-no-lambda
              onClick={() => { onView(record.id); }}
            />
            {/* <Popconfirm
              title="Are you sure you want to delete this merchant?"
              // tslint:disable-next-line:jsx-no-lambda
              onConfirm={() => { onDelete(record.id); }}
              // onCancel={cancel} 
              okText="Yes"
              cancelText="No"
            >
              <Tooltip placement="top" title="Click to delete merchant">
                <Button icon="delete" />
              </Tooltip>
            </Popconfirm> */}

          </ButtonGroup>
        );
      }
    }
    ];

    const data = this.state.status === 'loaded' ? this.state.data : [];

    const dataSource = data.map((d, i) => ({
      no: i + 1,
      ...d
    }));

    return (
      <Card
        loading={this.state.status === 'loading'}
        title="Merchants List"
        bordered={true}
        bodyStyle={{ padding: 10 }}
        extra={
          <Button type="primary" icon="plus" onClick={this.handleOnAdd}>
            Create
              </Button>
        }>
        <Table
          columns={this.columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="no"
          size="middle"
          bordered={true}
        />
      </Card>
    );
  }
}

export default connect(() => ({}), mapDispatchToProps)(MerchantList);



// WEBPACK FOOTER //
// ./src/merchants/containers/MerchantList.tsx